import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { CSP_CONFIG_ROUTE, SYSTEM, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';
import CspConfigCreate from './containers/CspConfigCreate';
import CspConfigEdit from './containers/CspConfigEdit';
import CspConfigList from './containers/CspConfigList';
import CspConfigView from './containers/CspConfigView';

interface Props {
  // The CSP pages are reachable from System Configuration and from People > Tenant
  basePath?: string
}

const CspConfig: FunctionComponent<Props> = ({
  basePath = `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CSP_CONFIG_ROUTE}`,
}: Props) => {
  return (
    <Fragment>
      <Route exact path={basePath}>
        <CspConfigList />
      </Route>
      <Route exact path={`${basePath}/create`}>
        <CspConfigCreate />
      </Route>
      <Route exact path={`${basePath}/edit`}>
        <CspConfigEdit />
      </Route>
      <Route exact path={`${basePath}/view`}>
        <CspConfigView />
      </Route>
    </Fragment>
  );
};

export default CspConfig;
